import { getLink } from "../../utils";
import React from 'react';
import "./index.less";
var TextPanel = function TextPanel(props) {
  var _props$subMenus = props.subMenus,
    subMenus = _props$subMenus === void 0 ? [] : _props$subMenus,
    originUrl = props.originUrl;
  return /*#__PURE__*/React.createElement("ul", {
    className: "iron-header-panel"
  }, subMenus.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      className: "iron-header-text-item",
      "data-full": item === null || item === void 0 ? void 0 : item.full,
      key: item === null || item === void 0 ? void 0 : item.value
    }, /*#__PURE__*/React.createElement("a", {
      href: getLink(item === null || item === void 0 ? void 0 : item.href, originUrl),
      target: item === null || item === void 0 ? void 0 : item.target
    }, /*#__PURE__*/React.createElement("span", {
      className: "iron-header-panel-title"
    }, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: (item === null || item === void 0 ? void 0 : item.label) || ''
      }
    }), item.des && /*#__PURE__*/React.createElement("span", {
      className: "desc"
    }, item.des))), item.tag && /*#__PURE__*/React.createElement("span", {
      className: "iron-header-panel-tag"
    }, item.tag));
  }));
};
export default TextPanel;